import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Services } from '@/infra/services';
import { type ItemId } from '@/infra/services/catalog/model';
import { type Response } from '@/infra/services/catalog/store/get-stocks';

interface UseStoreStockProps {
  itemId: ItemId;
}

type StoreStockQueryOptions = Omit<
  UseQueryOptions<Response, Error, Response>,
  'queryKey' | 'queryFn'
>;

const useStoreStock = (
  props: UseStoreStockProps,
  options?: StoreStockQueryOptions
) => {
  const { itemId } = props;

  const result = useQuery<Response, Error, Response>({
    queryKey: ['get-store-stock', itemId],
    queryFn: () => Services.Catalog.Store.getStocks({ itemId }),
    refetchOnMount: false,
    keepPreviousData: true,
    ...options,
  });

  return result;
};

export default useStoreStock;
